/**
 *   数字千分位分割
 */
export function formatThousandSeparator(price?: number | string): string {
  if (!price) {
    return "0";
  }

  const priceStr = String(price);
  const result = priceStr.replace(/\d+/, function (n) {
    // 取整数
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + ",";
    });
  });

  return result;
}
